import { Injectable } from '@angular/core';
import { DossierIntervention } from 'app/models/dossier_intervention.model';
import { Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { PhotoLieu } from 'app/models/photoLieu.model';
import {PieceEquipement} from '../models/pieceEquipement.model';
import {Croquis} from '../models/croquis.model';
import {ActiviteAssechement} from '../models/activiteAssechement.model';
import {FormulaireAutorisationIntervention} from '../models/formulaireAutorisationIntervention.model';
import {ActiviteEau} from '../models/activiteEau.model';
import {Piece} from '../models/piece.model';

@Injectable({
  providedIn: 'root'
})
export class DossierInterventionService {

  private API_URL= environment.API_URL;
  private MODEL_URL='dossiers-interventions';

  constructor(private http: HttpClient) { }

  getDossiersInterventions(): Observable<DossierIntervention[]> {
    return this.http.get<DossierIntervention[]>(this.API_URL + this.MODEL_URL);
  }

  getDossiersInterventionsForUser(user_id: string, search: string = null): Observable<DossierIntervention[]> {
      if (search) {
          return this.http.get<DossierIntervention[]>(this.API_URL + this.MODEL_URL + '/user/' + user_id, {params: {search}});
      }
      return this.http.get<DossierIntervention[]>(this.API_URL + this.MODEL_URL + '/user/' + user_id);
  }

  getDossierIntervention(id: number): Observable<DossierIntervention>{
    return this.http.get<DossierIntervention>(this.API_URL + this.MODEL_URL + '/' + id).pipe(
      catchError(err => throwError(err))
    );
  }

  getLastDossierInterventonIdWithUserId(userId: number): Observable<number>{
    return this.http.get<number>(this.API_URL + this.MODEL_URL + '/user/' + userId + '/last-id').pipe(
      catchError(err => throwError(err))
    );
  }

  store(dossierIntervention: DossierIntervention): Observable<DossierIntervention>{
    return this.http.post<DossierIntervention>(this.API_URL + this.MODEL_URL, dossierIntervention).pipe(
      catchError(err => throwError(err))
    );
  }

  update(dossierIntervention: DossierIntervention, id: number): Observable<DossierIntervention>{
    return this.http.put<DossierIntervention>(this.API_URL + this.MODEL_URL + '/' + id, dossierIntervention).pipe(
      catchError(err => throwError(err))
    );
  }

  delete(id: number): Observable<any>{
    return this.http.delete(this.API_URL + this.MODEL_URL + '/' + id).pipe(
      catchError(err => throwError(err))
    );
  }

  getPhotosParIdDossierIntervention(id: number): Observable<any>{
    return this.http.get<any>(this.API_URL + this.MODEL_URL + '/' + id + '/photos').pipe(
      catchError(err => throwError(err))
    );
  }
  getPiecesForDossierIntervention(id: number): Observable<any>{
    return this.http.get<any>(this.API_URL + this.MODEL_URL + '/' + id + '/pieces').pipe(
      catchError(err => throwError(err))
    );
  }

  storePieceEquipementForDossierIntervention(id: number, pieceEquipement: PieceEquipement): Observable<any>{
        return this.http.post<any>(this.API_URL + this.MODEL_URL + '/' + id + '/pieces-equipements', pieceEquipement).pipe(
            catchError(err => throwError(err))
        );
    }

  updatePieceEquipementForDossierIntervention(id: number, pieceEquipement: PieceEquipement): Observable<any>{
        return this.http.put<any>(this.API_URL + this.MODEL_URL + '/' + id + '/pieces-equipements/' + pieceEquipement.id, pieceEquipement).pipe(
            catchError(err => throwError(err))
        );
    }

  destroyPieceEquipementForDossierIntervention(id: number, pieceEquipement: PieceEquipement): Observable<any>{
        return this.http.delete<any>(this.API_URL + this.MODEL_URL + '/' + id + '/pieces-equipements/' + pieceEquipement.id).pipe(
            catchError(err => throwError(err))
        );
    }

    getCroquisForDossierIntervention(id: number): Observable<any>{
        return this.http.get<any>(this.API_URL + this.MODEL_URL + '/' + id + '/croquis').pipe(
            catchError(err => throwError(err))
        );
    }

    getEtagesForDossierIntervention(idDossierIntervention: number): Observable<any> {
        return this.http.get<any>(this.API_URL + this.MODEL_URL + '/' + idDossierIntervention + '/etages').pipe(
            catchError(err => throwError(err))
        );
    }

    storeCroquisForDossierIntervention(idDossierIntervention: number, croquis: Croquis): Observable<any> {
        return this.http.post<any>(this.API_URL + this.MODEL_URL + '/' + idDossierIntervention + '/croquis', croquis).pipe(
            catchError(err => throwError(err))
        );
    }

    updateCroquisForDossierIntervention(idDossierIntervention: number, croquis: any): Observable<any> {
        return this.http.put<any>(this.API_URL + this.MODEL_URL + '/' + idDossierIntervention + '/croquis/' + croquis.id, croquis).pipe(
            catchError(err => throwError(err))
        );
    }

    getRapportPsychometrique(id: number): Observable<any> {
        return this.http.get<any>(this.API_URL + this.MODEL_URL + '/' + id + '/rapport-psychometrique').pipe(
            catchError(err => throwError(err))
        );
    }

    getActiviteAssechementsForDossierIntervention(id: number): Observable<ActiviteAssechement[]> {
        return this.http.get<ActiviteAssechement[]>(this.API_URL + this.MODEL_URL + '/' + id + '/activite-assechements').pipe(
            catchError(err => throwError(err))
        );
    }
    getActiviteEauxForDossierIntervention(id: number): Observable<ActiviteEau[]> {
        return this.http.get<ActiviteEau[]>(this.API_URL + this.MODEL_URL + '/' + id + '/activite-eaux').pipe(
            catchError(err => throwError(err))
        );
    }
    storeOrUpdateActiviteAssechementsForDossierIntervention(id: number, activiteAssechement: ActiviteAssechement): Observable<ActiviteAssechement> {
      if (activiteAssechement.id) {
          return this.http.put<ActiviteAssechement>(this.API_URL + this.MODEL_URL + '/' + id + '/activite-assechements/' + activiteAssechement.id, activiteAssechement).pipe(
              catchError(err => throwError(err))
          );
      } else {
          return this.http.post<ActiviteAssechement>(this.API_URL + this.MODEL_URL + '/' + id + '/activite-assechements', activiteAssechement).pipe(
              catchError(err => throwError(err))
          );
      }
    }

    getSurfacesForDossierIntervention(id: number): Observable<string[]> {
        return this.http.get<string[]>(this.API_URL + this.MODEL_URL + '/' + id + '/surfaces').pipe(
            catchError(err => throwError(err))
        );
    }

    getMaterialsForDossierIntervention(id: number) {
        return this.http.get<string[]>(this.API_URL + this.MODEL_URL + '/' + id + '/materials').pipe(
            catchError(err => throwError(err))
        );
    }

    getFormaulaireAutorisationIntervention(id: number) {
        return this.http.get<FormulaireAutorisationIntervention>(this.API_URL + this.MODEL_URL + '/' + id + '/creance').pipe(
            catchError(err => throwError(err))
        );
    }

    storeOrUpdateActiviteEauxForDossierIntervention(dossier_intervention_id: number, activiteEau: ActiviteEau) {
        if (activiteEau.id) {
            return this.http.put<ActiviteEau>(this.API_URL + this.MODEL_URL + '/' + dossier_intervention_id + '/activite-eaux/' + activiteEau.id, activiteEau).pipe(
                catchError(err => throwError(err))
            );
        } else {
            return this.http.post<ActiviteEau>(this.API_URL + this.MODEL_URL + '/' + dossier_intervention_id + '/activite-eaux', activiteEau).pipe(
                catchError(err => throwError(err))
            );
        }
    }

    storeOrUpdatePieceForDossierIntervention(idDossierIntervention: number, piece: Piece): Observable<Piece> {
        if (piece.id) {
            return this.http.put<Piece>(this.API_URL + this.MODEL_URL + '/' + idDossierIntervention + '/pieces/' + piece.id, piece).pipe(
                catchError(err => throwError(err))
            );
        } else {
            return this.http.post<Piece>(this.API_URL + this.MODEL_URL + '/' + idDossierIntervention + '/pieces', piece).pipe(
                catchError(err => throwError(err))
            );
        }
    }
}
